import { render, staticRenderFns } from "./LetterForm.vue?vue&type=template&id=5a710424&scoped=true&"
import script from "./LetterForm.vue?vue&type=script&lang=ts&"
export * from "./LetterForm.vue?vue&type=script&lang=ts&"
import style0 from "./LetterForm.vue?vue&type=style&index=0&id=5a710424&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a710424",
  null
  
)

export default component.exports